module.exports = __webpack_public_path__ + "static/media/lengerich.cca938bd.jpg";